import { render } from "./dashSkillsView.vue?vue&type=template&id=3981a238"
import script from "./dashSkillsView.vue?vue&type=script&lang=js"
export * from "./dashSkillsView.vue?vue&type=script&lang=js"

import "./dashSkillsView.vue?vue&type=style&index=0&id=3981a238&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__